import { render, staticRenderFns } from "./zakelijke-verhuizingen.vue?vue&type=template&id=3b245917"
import script from "./zakelijke-verhuizingen.vue?vue&type=script&lang=js"
export * from "./zakelijke-verhuizingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports